import { Facebook, Instagram, MessageCircle } from "lucide-react";
const socials = [
  { label:"Instagram", Icon:Instagram, href:"https://www.instagram.com/weddingtouch.in?stkn=MXIyZzF4eW5uMXdhOA==" },
  { label:"Facebook", Icon:Facebook, href:"https://www.facebook.com/share/1Q8kNN3RLM/?mibextid=wwXIfr" },
  { label:"WhatsApp", Icon:MessageCircle, href:"https://wa.me/919933420292" },
];
export default function FloatingSocials() {
  return <aside className="floating-socials" aria-label="Social media"><span className="social-caption">Follow</span>{socials.map(({label,Icon,href})=><a key={label} href={href} target="_blank" rel="noreferrer" aria-label={label} title={label}><Icon size={18} strokeWidth={1.7}/></a>)}</aside>;
}